module.exports = __webpack_public_path__ + "img/select.c3a58dc3.svg";